import storeConfig from './storeConfig';

const store = storeConfig();

export default store;
